
  var _styles = {
  "suggest-area-item-container": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "width": "9.14667rem",
    "height": "1.33333rem",
    "margin": "auto",
    "paddingTop": "0.18667rem",
    "paddingRight": 0,
    "paddingBottom": "0.18667rem",
    "paddingLeft": 0,
    "backgroundColor": "rgb(255,255,255)"
  },
  "suggest-area-item-left": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "suggest-area-item-icon": {
    "width": "0.32rem",
    "height": "0.37333rem",
    "marginRight": "0.26667rem"
  },
  "suggest-area-item-name": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(0,0,0)",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  